import { render } from "./DatenblattMod.vue?vue&type=template&id=31a07cce&scoped=true"
import script from "./DatenblattMod.vue?vue&type=script&lang=js"
export * from "./DatenblattMod.vue?vue&type=script&lang=js"

import "./DatenblattMod.vue?vue&type=style&index=0&id=31a07cce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\AirFryer\\AirFryer_Berater\\AirFryer_Kaufberatung\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a07cce"]])

export default __exports__